import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";
import { SetGetUserById } from "./setGetUserById";

const setPostUserWagerSettings = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: params.type === 'pay' ? urls.POST_WAGERPAY : urls.POST_WAGERFRESSPIN
            });
            dispatch(SetGetUserById(params.id))
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostUserWagerSettings as SetPostUserWagerSettings
}